import { AfterViewInit, Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[viBorderBottom]',
})
export class ViBorderBottomDirective implements AfterViewInit {
  readonly largeScreenSizeBreakPoint = 1084;
  readonly smallScreenSizeBreakPoint = 576;

  gridContainer;
  maxColumnAmount: number;
  maxRowAmount: number;

  constructor(private elementRef: ElementRef) {
    this.gridContainer = this.elementRef.nativeElement;
  }

  ngAfterViewInit(): void {
    this.setBorderBottom();
  }

  @HostListener('window:resize')
  setBorderBottom() {
    const gridContainerWidth = this.gridContainer?.clientWidth;
    const gridContainerElements = this.gridContainer?.children?.length;
    switch (true) {
      case gridContainerWidth > this.largeScreenSizeBreakPoint:
        this.maxColumnAmount = 3;
        this.maxRowAmount = Math.ceil(gridContainerElements / this.maxColumnAmount);
        if (this.gridContainer.children[this.maxRowAmount - 1]?.children) {
          this.gridContainer.children[this.maxRowAmount - 1].children[0].style.borderStyle = 'none';
        }
        if (this.gridContainer.children[this.maxRowAmount * 2 - 1]?.children) {
          this.gridContainer.children[this.maxRowAmount * 2 - 1].children[0].style.borderStyle =
            'none';
        }

        if (this.gridContainer.children[this.maxRowAmount * 3 - 1]?.children) {
          this.gridContainer.children[this.maxRowAmount * 3 - 1].children[0].style.borderStyle =
            'none';
        }
        for (let i = 0; i < this.gridContainer.children.length; i++) {
          const element = this.gridContainer.children[i];
          if (
            i !== this.maxRowAmount - 1 &&
            i !== this.maxRowAmount * 2 - 1 &&
            i !== this.maxRowAmount * 3 - 1
          ) {
            element.children[0].removeAttribute('style');
          }
        }
        break;
      case gridContainerWidth < this.largeScreenSizeBreakPoint &&
        gridContainerWidth > this.smallScreenSizeBreakPoint:
        this.maxColumnAmount = 2;
        this.maxRowAmount = Math.ceil(gridContainerElements / this.maxColumnAmount);
        if (this.gridContainer.children[this.maxRowAmount - 1]?.children) {
          this.gridContainer.children[this.maxRowAmount - 1].children[0].style.borderStyle = 'none';
        }
        if (this.gridContainer.children[this.maxRowAmount * 2 - 1]?.children) {
          this.gridContainer.children[this.maxRowAmount * 2 - 1].children[0].style.borderStyle =
            'none';
        }
        for (let i = 0; i < this.gridContainer.children.length; i++) {
          const element = this.gridContainer.children[i];
          if (i !== this.maxRowAmount - 1 && i !== this.maxRowAmount * 2 - 1) {
            element.children[0].removeAttribute('style');
          }
        }
        break;
      default:
        this.maxColumnAmount = 1;
        this.maxRowAmount = Math.ceil(gridContainerElements / this.maxColumnAmount);
        if (this.gridContainer.children[gridContainerElements - 1]?.children) {
          this.gridContainer.children[gridContainerElements - 1].children[0].style.borderStyle =
            'none';
        }
        for (let i = 0; i < this.gridContainer.children.length; i++) {
          const element = this.gridContainer.children[i];
          if (i !== this.gridContainer.children.length - 1) {
            element.children[0].removeAttribute('style');
          }
        }
        break;
    }
  }
}
